// src/modules/operaciones/inventarios/utils/trasladosComun.js
//
// Helper compartido por la vista de Traslados y su tabla (movido tal cual desde InventariosTraslados.js).

export const fechaDe = (t) => (t.FECHA ? String(t.FECHA).split('T')[0] : '');